export const handleGetIdSheet = (value) => {
  const sheetIdReg = /\/d\/([a-zA-Z0-9_-]+)\//;
  if (value && value.match(sheetIdReg)) {
    return value.match(sheetIdReg)[1];
  }
  return null;
};
